import script from "./InputView.vue?vue&type=script&setup=true&lang=js"
export * from "./InputView.vue?vue&type=script&setup=true&lang=js"

import "./InputView.vue?vue&type=style&index=0&id=2d47c681&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d47c681"]])

export default __exports__